<template>
  <v-text-field
    :class="{'center-text-input': centered}"
    :dense="dense"
    :outlined="outlined"
    required
    :label="label"
    :persistent-hint="!!hint"
    :hint="hint"
    :help="help"
    :value="localInput"
    @input="setInput"
    :placeholder="placeHolder"
    :readonly="readonly"
    :data-vv-name="fullPath"
    :data-vv-as="alias"
    :success="success"
    :error-messages="errorMessages"
    :hide-details="hideDetails && !errorMessages.length"
    v-validate="validatorRule"
  >
  </v-text-field>
</template>
<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FieldMixin from '@/components/Mixins/FieldMixin.vue';
import _string from '@/helpers/stringHelper';

@Component({
  components: {
  }
})
export default class NumberField extends Mixins(FieldMixin) {

  @Prop({ type: [String], default: undefined })
  public declare readonly input: string | undefined;

  @Prop({ type: [String], default: undefined })
  public readonly placeHolder: string | undefined;

  @Prop({ type: [String], default: undefined })
  public readonly hint: string | undefined;

  @Prop({ type: [String], default: undefined })
  public readonly help: string | undefined;

  @Prop({ default: () => ({ regex: /\d+\.?\d*/ }) })
  public readonly validatorRule: any;

  @Prop({ type: [Boolean], default: () => false })
  public readonly allowHtml: boolean | undefined;

  protected localInput: string | null = null;

  // METHOD =======================================================
  private setInput(value: string | null | undefined) {
    if (this.isNotDefined(value)) {
      this.localInput = null;
      this.$emit('setInput', this.localInput);
      return;
    }
    if (!this.allowHtml) {
      value = _string.sanitize(value!);
    }
    this.localInput = value === '' ? null : value!;
    this.$emit('setInput', this.localInput);
  }
}
</script>
